import tippy, { Instance, Options } from 'tippy.js';

export interface TippyHTMLElement extends HTMLElement {
  _tippy?: Instance;
}

export default class Tooltip {
  static TOOLTIP_CLASS = 'js-tooltip';

  private instance: Instance;

  constructor(element: HTMLElement, content?: string, options?: Options) {
    this.instance = tippy(element, {
      animation: 'scale',
      theme: 'eparts',
      content,
      ...options,
    }) as Instance;
  }

  destroy(): void {
    this.instance.destroy();
  }

  setContent(content: string): void {
    this.instance.setContent(content);
  }

  static initAll(): void {
    const elements: NodeListOf<Element> = document.querySelectorAll(`.${this.TOOLTIP_CLASS}`);

    elements.forEach((item) => {
      tippy(item, {
        animation: 'scale',
        theme: item.getAttribute('data-tippy-theme') ?? 'eparts',
      });
    });
  }
}
